<template>
  <UsuariosExtLayout
    title="Recargar tarjeta"
    subtitle="Añade saldo de forma rápida y segura"
    description="Completa el formulario paso a paso, valida tu tarjeta y realiza el pago en línea."
    :show-back="true"
    narrow
  >
    <loading v-if="cargando" />

    <div class="conecta-form-card">
      <form-wizard
        ref="wizard"
        title="Recarga Tu tarjeta"
        subtitle="Añade saldo de forma rápida y segura"
        @on-complete="submitPayment"
        color="#05A85A"
        back-button-text="Anterior"
        next-button-text="Siguiente"
        finish-button-text="Finalizar y pagar"
      >
        <!-- Paso 1: Número de Tarjeta -->
        <tab-content
          title="Número de Tarjeta"
          :before-change="validateStep1"
          icon="fas fa-credit-card"
        >
          <div class="mb-3">
            <label for="no_tarjeta" class="conecta-form-label">
              <i class="fas fa-credit-card"></i>
              Número de Tarjeta <span class="text-danger">*</span>
            </label>
            <input
              v-model="form.no_tarjeta"
              type="text"
              id="no_tarjeta"
              v-only-numbers
              maxlength="19"
              class="form-control conecta-form-control"
              :class="claseCampo('no_tarjeta')"
              placeholder="Ingrese el número de tarjeta"
              @input="onTarjetaInput"
              @blur="$v.form.no_tarjeta.$touch()"
            />
            <div v-if="$v.form.no_tarjeta.$error" class="conecta-invalid-feedback">
              <i class="fas fa-exclamation-circle mr-1"></i>
              {{ mensajeCampo("no_tarjeta") }}
            </div>
            <small class="conecta-form-hint d-block mt-2">
              <i class="fas fa-info-circle mr-1"></i>
              Al continuar se validará su tarjeta antes de pedir el resto de datos.
            </small>
          </div>
        </tab-content>

        <!-- Paso 2: Datos de la recarga -->
        <tab-content
          title="Datos de la Recarga"
          :before-change="validateStep2"
          icon="fas fa-user"
        >
          <div class="row">
            <div class="col-md-6 mb-3">
              <label for="no_documento" class="conecta-form-label">
                <i class="fas fa-id-card"></i>
                Documento de Identidad <span class="text-danger">*</span>
              </label>
              <input
                v-model="form.no_documento"
                type="text"
                id="no_documento"
                v-only-numbers
                maxlength="12"
                class="form-control conecta-form-control"
                :class="claseCampo('no_documento')"
                placeholder="0000000000"
                @blur="$v.form.no_documento.$touch()"
              />
              <div v-if="$v.form.no_documento.$error" class="conecta-invalid-feedback">
                <i class="fas fa-exclamation-circle mr-1"></i>
                {{ mensajeCampo("no_documento") }}
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label for="nombre" class="conecta-form-label">
                <i class="fas fa-user"></i>
                Nombre <span class="text-danger">*</span>
              </label>
              <input
                v-model="form.nombre"
                type="text"
                id="nombre"
                class="form-control conecta-form-control"
                :class="claseCampo('nombre')"
                placeholder="Tu nombre"
                @blur="$v.form.nombre.$touch()"
              />
              <div v-if="$v.form.nombre.$error" class="conecta-invalid-feedback">
                <i class="fas fa-exclamation-circle mr-1"></i>
                {{ mensajeCampo("nombre") }}
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 mb-3">
              <label for="email" class="conecta-form-label">
                <i class="fas fa-envelope"></i>
                Correo notificaciones <span class="text-danger">*</span>
              </label>
              <input
                v-model="form.email"
                type="email"
                id="email"
                class="form-control conecta-form-control"
                :class="claseCampo('email')"
                placeholder="tu@correo.com"
                @blur="$v.form.email.$touch()"
              />
              <div v-if="$v.form.email.$error" class="conecta-invalid-feedback">
                <i class="fas fa-exclamation-circle mr-1"></i>
                {{ mensajeCampo("email") }}
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label for="telefono" class="conecta-form-label">
                <i class="fas fa-phone"></i>
                Teléfono <span class="text-danger">*</span>
              </label>
              <input
                v-model="form.telefono"
                type="text"
                id="telefono"
                v-only-numbers
                maxlength="10"
                class="form-control conecta-form-control"
                :class="claseCampo('telefono')"
                placeholder="300 000 0000"
                @blur="$v.form.telefono.$touch()"
              />
              <div v-if="$v.form.telefono.$error" class="conecta-invalid-feedback">
                <i class="fas fa-exclamation-circle mr-1"></i>
                {{ mensajeCampo("telefono") }}
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 mb-3">
              <label for="monto" class="conecta-form-label">
                <i class="fas fa-dollar-sign"></i>
                Monto <span class="text-danger">*</span>
              </label>
              <input
                v-model="form.monto"
                type="text"
                id="monto"
                v-only-numbers
                @input="onMontoInput"
                maxlength="6"
                class="form-control conecta-form-control"
                :class="claseCampo('monto')"
                :placeholder="`$ ${MONTO_MINIMO}`"
                @blur="$v.form.monto.$touch()"
              />
              <div v-if="$v.form.monto.$error" class="conecta-invalid-feedback">
                <i class="fas fa-exclamation-circle mr-1"></i>
                {{ mensajeCampo("monto") }}
              </div>
              <small class="conecta-form-hint d-block">
                Mínimo $ {{ MONTO_MINIMO.toLocaleString("es-CO") }} — Máximo $
                {{ MONTO_MAXIMO.toLocaleString("es-CO") }}
              </small>
            </div>

            <div class="col-md-6 mb-3">
              <label for="ciudad" class="conecta-form-label">
                <i class="fas fa-city"></i>
                Ciudad / Municipio <span class="text-danger">*</span>
              </label>
              <input
                v-model="form.ciudad"
                type="text"
                id="ciudad"
                class="form-control conecta-form-control"
                :class="claseCampo('ciudad')"
                placeholder="Bogotá"
                @blur="$v.form.ciudad.$touch()"
              />
              <div v-if="$v.form.ciudad.$error" class="conecta-invalid-feedback">
                <i class="fas fa-exclamation-circle mr-1"></i>
                {{ mensajeCampo("ciudad") }}
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 mb-3">
              <label for="direccion" class="conecta-form-label">
                <i class="fas fa-map-marker-alt"></i>
                Dirección <span class="text-danger">*</span>
              </label>
              <input
                v-model="form.direccion"
                type="text"
                id="direccion"
                class="form-control conecta-form-control"
                :class="claseCampo('direccion')"
                placeholder="Tu dirección"
                @blur="$v.form.direccion.$touch()"
              />
              <div v-if="$v.form.direccion.$error" class="conecta-invalid-feedback">
                <i class="fas fa-exclamation-circle mr-1"></i>
                {{ mensajeCampo("direccion") }}
              </div>
            </div>
          </div>

          <div class="mb-3">
            <div class="form-check">
              <input
                v-model="form.tratamiento_datos"
                type="checkbox"
                id="tratamiento_datos"
                class="form-check-input"
                :class="{ 'is-invalid': $v.form.tratamiento_datos.$error }"
                @change="$v.form.tratamiento_datos.$touch()"
              />
              <label class="form-check-label conecta-form-check-label" for="tratamiento_datos">
                <i class="fas fa-shield-alt mr-1"></i>
                Autorizo el
                <a href="/tratamiento-datos-personales" target="_blank">
                  tratamiento de mis datos personales
                </a>
                <span class="text-danger">*</span>
              </label>
              <div v-if="$v.form.tratamiento_datos.$error" class="conecta-invalid-feedback">
                <i class="fas fa-exclamation-circle mr-1"></i>
                {{ mensajeCampo("tratamiento_datos") }}
              </div>
            </div>
          </div>

          <div class="mb-3">
            <div class="form-check">
              <input
                v-model="form.terminos_condiciones"
                type="checkbox"
                id="terminos_condiciones"
                class="form-check-input"
                :class="{ 'is-invalid': $v.form.terminos_condiciones.$error }"
                @change="$v.form.terminos_condiciones.$touch()"
              />
              <label class="form-check-label conecta-form-check-label" for="terminos_condiciones">
                <i class="fas fa-file-contract mr-1"></i>
                Acepto los
                <a href="/terminos-condiciones-tarjetas" target="_blank">
                  términos y condiciones
                </a>
                <span class="text-danger">*</span>
              </label>
              <div v-if="$v.form.terminos_condiciones.$error" class="conecta-invalid-feedback">
                <i class="fas fa-exclamation-circle mr-1"></i>
                {{ mensajeCampo("terminos_condiciones") }}
              </div>
            </div>
          </div>
        </tab-content>

        <!-- Paso 3: Confirmación -->
        <tab-content
          title="Confirmación"
          :before-change="validateStep3"
          icon="fas fa-check-circle"
        >
          <div class="alert alert-light border mb-3">
            <h6 class="mb-3 text-success">
              <i class="fas fa-receipt mr-1"></i>
              Resumen de la recarga
            </h6>
            <div class="table-responsive">
              <table class="table table-sm table-bordered mb-0 bg-white">
                <tbody>
                  <tr>
                    <th style="width: 40%;">Número de tarjeta</th>
                    <td>{{ form.no_tarjeta || "—" }}</td>
                  </tr>
                  <tr>
                    <th>Documento</th>
                    <td>{{ form.no_documento || "—" }}</td>
                  </tr>
                  <tr>
                    <th>Nombre</th>
                    <td>{{ form.nombre || "—" }}</td>
                  </tr>
                  <tr>
                    <th>Correo</th>
                    <td>{{ form.email || "—" }}</td>
                  </tr>
                  <tr>
                    <th>Teléfono</th>
                    <td>{{ form.telefono || "—" }}</td>
                  </tr>
                  <tr>
                    <th>Ciudad</th>
                    <td>{{ form.ciudad || "—" }}</td>
                  </tr>
                  <tr>
                    <th>Dirección</th>
                    <td>{{ form.direccion || "—" }}</td>
                  </tr>
                  <tr>
                    <th>Monto a recargar</th>
                    <td class="font-weight-bold text-success">
                      $ {{ montoNumero.toLocaleString("es-CO") }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="mb-3">
            <div class="d-flex justify-content-center">
              <div id="recaptcha-container"></div>
            </div>
            <div v-if="errors.recaptcha" class="conecta-invalid-feedback text-center mt-2">
              <i class="fas fa-exclamation-circle mr-1"></i>
              {{ errors.recaptcha }}
            </div>
          </div>

          <p class="text-muted small text-center mb-0">
            Al finalizar se abrirá la pasarela de pagos ePayco para completar la recarga.
          </p>
        </tab-content>
      </form-wizard>

      <div class="d-flex justify-content-center mt-3">
        <button type="button" class="btn conecta-btn-outline px-4 py-2" @click="limpiarFormulario">
          <i class="fas fa-undo mr-2"></i>
          Limpiar formulario
        </button>
      </div>

      <div v-if="mensaje" class="alert alert-info mt-3 mb-0">{{ mensaje }}</div>
    </div>
  </UsuariosExtLayout>
</template>

<script>
import axios from "axios";
import {
  required,
  email,
  minLength,
  maxLength,
  numeric,
} from "vuelidate/lib/validators";
import Loading from "../../components/LoadingSpinner";
import UsuariosExtLayout from "../../components/usuariosExt/UsuariosExtLayout.vue";

const MONTO_MINIMO = 10000;
const MONTO_MAXIMO = 300000;

const aceptado = (value) => value === true;

const montoMinimo = (min) => (value) => {
  const n = Number(String(value ?? "").replace(/\D/g, ""));
  return Number.isFinite(n) && n >= min;
};

const montoMaximo = (max) => (value) => {
  const n = Number(String(value ?? "").replace(/\D/g, ""));
  return Number.isFinite(n) && n <= max;
};

export default {
  name: "EpaycoView",

  components: {
    Loading,
    UsuariosExtLayout,
  },

  data() {
    return {
      MONTO_MINIMO,
      MONTO_MAXIMO,
      form: {
        no_tarjeta: "",
        no_documento: "",
        nombre: "",
        monto: "",
        referencia: "",
        telefono: "",
        email: "",
        observacion: "",
        departamento: "",
        ciudad: "",
        direccion: "",
        estado: 1,
        tratamiento_datos: false,
        terminos_condiciones: false,
      },
      valTarjeta: false,
      mensaje: "",
      cargando: false,
      recaptchaToken: null,
      recaptchaWidgetId: null,
      errors: {},
      tarjetaValidada: "",
    };
  },

  validations() {
    return {
      form: {
        no_tarjeta: {
          required,
          numeric,
          minLength: minLength(10),
          maxLength: maxLength(19),
        },
        no_documento: {
          required,
          numeric,
          minLength: minLength(6),
          maxLength: maxLength(12),
        },
        nombre: {
          required,
          minLength: minLength(2),
        },
        email: {
          required,
          email,
        },
        telefono: {
          required,
          numeric,
          minLength: minLength(7),
          maxLength: maxLength(10),
        },
        monto: {
          required,
          numeric,
          montoMinimo: montoMinimo(MONTO_MINIMO),
          montoMaximo: montoMaximo(MONTO_MAXIMO),
        },
        ciudad: {
          required,
          minLength: minLength(2),
        },
        direccion: {
          required,
          minLength: minLength(5),
        },
        tratamiento_datos: {
          aceptado,
        },
        terminos_condiciones: {
          aceptado,
        },
      },
    };
  },

  computed: {
    montoNumero() {
      const n = Number(String(this.form.monto ?? "").replace(/\D/g, ""));
      return Number.isFinite(n) ? n : 0;
    },
  },

  mounted() {
    if (typeof window.ePayco === "undefined") {
      const script = document.createElement("script");
      script.src = "https://checkout.epayco.co/checkout.js";
      script.async = true;
      document.head.appendChild(script);
    }

    this.loadRecaptcha();
  },

  beforeDestroy() {
    if (this.recaptchaWidgetId !== null && window.grecaptcha) {
      try {
        window.grecaptcha.reset(this.recaptchaWidgetId);
      } catch (e) {
        console.log("Error al resetear reCAPTCHA:", e);
      }
    }
  },

  methods: {
    claseCampo(campo) {
      const field = this.$v.form[campo];
      if (!field) return {};
      return {
        "is-invalid": field.$error,
        "is-valid": field.$dirty && !field.$invalid,
      };
    },

    mensajeCampo(campo) {
      const field = this.$v.form[campo];
      if (!field || !field.$error) return "";

      const mensajes = {
        no_tarjeta: {
          required: "El número de tarjeta es obligatorio.",
          numeric: "Solo se permiten números.",
          minLength: "Debe tener entre 10 y 19 dígitos.",
          maxLength: "Debe tener entre 10 y 19 dígitos.",
        },
        no_documento: {
          required: "El documento de identidad es obligatorio.",
          numeric: "Solo se permiten números.",
          minLength: "Debe tener entre 6 y 12 dígitos.",
          maxLength: "Debe tener entre 6 y 12 dígitos.",
        },
        nombre: {
          required: "El nombre es obligatorio.",
          minLength: "Ingrese al menos 2 caracteres.",
        },
        email: {
          required: "El correo electrónico es obligatorio.",
          email: "Ingrese un correo electrónico válido.",
        },
        telefono: {
          required: "El teléfono es obligatorio.",
          numeric: "Solo se permiten números.",
          minLength: "Debe tener entre 7 y 10 dígitos.",
          maxLength: "Debe tener entre 7 y 10 dígitos.",
        },
        monto: {
          required: "El monto es obligatorio.",
          numeric: "Solo se permiten números.",
          montoMinimo: `El monto mínimo permitido es $ ${MONTO_MINIMO.toLocaleString("es-CO")}.`,
          montoMaximo: `El monto máximo permitido es $ ${MONTO_MAXIMO.toLocaleString("es-CO")}.`,
        },
        ciudad: {
          required: "La ciudad o municipio es obligatorio.",
          minLength: "Ingrese al menos 2 caracteres.",
        },
        direccion: {
          required: "La dirección es obligatoria.",
          minLength: "Ingrese al menos 5 caracteres.",
        },
        tratamiento_datos: {
          aceptado: "Debe autorizar el tratamiento de datos personales.",
        },
        terminos_condiciones: {
          aceptado: "Debe aceptar los términos y condiciones.",
        },
      };

      const reglas = mensajes[campo] || {};
      const reglaInvalida = Object.keys(reglas).find((regla) => !field[regla]);
      return reglaInvalida ? reglas[reglaInvalida] : "Campo inválido.";
    },

    onTarjetaInput() {
      if (this.form.no_tarjeta !== this.tarjetaValidada) {
        this.valTarjeta = false;
      }
    },

    onMontoInput(e) {
      const raw = e?.target?.value ?? this.form.monto ?? "";
      const digits = String(raw).replace(/\D/g, "");
      const n = Number(digits || 0);
      const clamped = Math.min(n, this.MONTO_MAXIMO);
      this.form.monto = clamped ? String(clamped) : "";
      this.$v.form.monto.$touch();
    },

    async validateStep1() {
      this.$v.form.no_tarjeta.$touch();

      if (this.$v.form.no_tarjeta.$invalid) {
        this.$swal.fire({
          icon: "warning",
          title: "Tarjeta inválida",
          text: this.mensajeCampo("no_tarjeta"),
          confirmButtonText: "Entendido",
        });
        return false;
      }

      if (this.valTarjeta && this.tarjetaValidada === this.form.no_tarjeta) {
        return true;
      }

      const ok = await this.validarTarjeta();
      if (!ok) {
        return false;
      }

      this.$nextTick(() => {
        this.renderRecaptcha();
      });

      return true;
    },

    validateStep2() {
      this.$v.form.no_documento.$touch();
      this.$v.form.nombre.$touch();
      this.$v.form.email.$touch();
      this.$v.form.telefono.$touch();
      this.$v.form.monto.$touch();
      this.$v.form.ciudad.$touch();
      this.$v.form.direccion.$touch();
      this.$v.form.tratamiento_datos.$touch();
      this.$v.form.terminos_condiciones.$touch();

      const invalid =
        this.$v.form.no_documento.$invalid ||
        this.$v.form.nombre.$invalid ||
        this.$v.form.email.$invalid ||
        this.$v.form.telefono.$invalid ||
        this.$v.form.monto.$invalid ||
        this.$v.form.ciudad.$invalid ||
        this.$v.form.direccion.$invalid ||
        this.$v.form.tratamiento_datos.$invalid ||
        this.$v.form.terminos_condiciones.$invalid;

      if (invalid) {
        this.$swal.fire({
          icon: "warning",
          title: "Campos incompletos",
          text: "Por favor revise los campos marcados en rojo antes de continuar.",
          confirmButtonText: "Entendido",
        });
        return false;
      }

      this.$nextTick(() => {
        this.renderRecaptcha();
      });

      return true;
    },

    validateStep3() {
      this.errors = { ...this.errors, recaptcha: null };

      if (!this.recaptchaToken) {
        this.errors.recaptcha = "Por favor, complete la verificación reCAPTCHA";
        this.$swal.fire({
          icon: "warning",
          title: "Verificación requerida",
          text: "Por favor, complete la verificación reCAPTCHA para continuar",
          confirmButtonText: "Entendido",
        });
        return false;
      }

      if (!this.valTarjeta) {
        this.$swal.fire({
          icon: "warning",
          title: "Tarjeta no validada",
          text: "Debe validar la tarjeta antes de proceder al pago.",
          confirmButtonText: "Entendido",
        });
        return false;
      }

      return true;
    },

    async submitPayment() {
      if (!this.validateStep3()) {
        return;
      }

      if (this.montoNumero > this.MONTO_MAXIMO) {
        this.form.monto = String(this.MONTO_MAXIMO);
      }

      if (typeof window.ePayco === "undefined") {
        this.$swal.fire({
          icon: "error",
          title: "Pasarela no disponible",
          text: "El script de ePayco aún no se ha cargado. Intente nuevamente.",
        });
        return;
      }

      this.form.recaptcha_token = this.recaptchaToken;

      await this.save();

      if (this.form.referencia === "") {
        this.$swal.fire({
          icon: "error",
          title: "Error",
          text: "Error al generar la referencia de pago. Intente nuevamente.",
        });
        return;
      }

      if (this.recaptchaWidgetId !== null && window.grecaptcha) {
        window.grecaptcha.reset(this.recaptchaWidgetId);
        this.recaptchaToken = null;
      }

      const handler = window.ePayco.checkout.configure({
        key: process.env.VUE_APP_EPAYCO_PUBLIC_KEY,
        test: false,
      });

      handler.open({
        name: "Recarga STS",
        description: "Recarga de saldo en STS",
        invoice: this.form.referencia,
        currency: "COP",
        amount: this.form.monto,
        tax_base: "0",
        tax: "0",
        country: "co",
        lang: "es",
        external: "false",
        extra1: "numero_tarjeta_" + this.form.no_tarjeta,
        extra2: "no_documento_" + this.form.no_documento,
        response: "https://back.conectasts.com/epayco/respuestaRecarga",
        confirmation: "https://back.conectasts.com/api/epayco/webhook",
        method: "POST",
      });

      this.mensaje = `Enviando pago con tarjeta: ${this.form.no_tarjeta} y documento: ${this.form.no_documento}`;
    },

    async save() {
      this.cargando = true;

      await axios
        .post("/api/recargaWeb", this.form)
        .then((response) => {
          this.cargando = false;
          this.form.referencia = response.data.id;
        })
        .catch((e) => {
          this.cargando = false;
          this.$swal({
            icon: "error",
            title: "Ocurrio un error, vuelva a intentarlo..." + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    /**
     * Valida la tarjeta contra el API. Retorna true si es válida.
     */
    async validarTarjeta() {
      this.cargando = true;

      try {
        const response = await axios.get("/api/getInfoTarjetas", {
          params: {
            tarjeta_externa: this.form.no_tarjeta,
          },
        });

        this.cargando = false;
        const res = response.data || {};

        if (Number(res.code) !== 0) {
          this.valTarjeta = false;
          this.$swal({
            icon: "error",
            title: res.message || "No se pudo validar la tarjeta",
            showConfirmButton: true,
          });
          return false;
        }

        const card = res.card_info || {};
        const user = res.user_info || {};

        if (card.tarjeta_duplicada === true || card.tarjeta_duplicada === 1) {
          this.valTarjeta = false;
          this.$swal({
            icon: "error",
            title: "Tarjeta duplicada",
            text: "La tarjeta aparece como duplicada y no puede usarse para recargar.",
            showConfirmButton: true,
          });
          return false;
        }

        if (this.tarjetaNoActiva(card)) {
          this.valTarjeta = false;
          this.$swal({
            icon: "error",
            title: "Tarjeta no activa",
            text:
              "La tarjeta no está activa" +
              (card.estado ? ` (estado: ${card.estado})` : "") +
              ". No es posible continuar con la recarga.",
            showConfirmButton: true,
          });
          return false;
        }

        this.aplicarDatosTarjeta(card, user);
        this.valTarjeta = true;
        this.tarjetaValidada = this.form.no_tarjeta;

        this.$swal({
          icon: "success",
          title: "Tarjeta válida",
          text: card.estado
            ? `Estado: ${card.estado}` +
              (card.saldo_actual != null ? ` | Saldo: $${card.saldo_actual}` : "")
            : "La tarjeta fue validada correctamente.",
          showConfirmButton: true,
        });

        return true;
      } catch (e) {
        this.cargando = false;
        this.valTarjeta = false;
        this.$swal({
          icon: "error",
          title: "Ocurrio un error, vuelva a intentarlo..." + e,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return false;
      }
    },

    /** Normaliza fecha a YYYY-MM-DD o null si no es válida */
    normalizarFecha(fecha) {
      if (!fecha) return null;
      const str = String(fecha).trim().substring(0, 10);
      if (!/^\d{4}-\d{2}-\d{2}$/.test(str)) return null;
      const d = new Date(str + "T00:00:00");
      if (Number.isNaN(d.getTime())) return null;
      return str;
    },

    /**
     * No activa si:
     * - estado distinto de Activa/Activo, o
     * - fecha_boletinada válida y distinta a 2000-01-01 (boletinada real).
     */
    tarjetaNoActiva(card) {
      const fecha = this.normalizarFecha(card.fecha_boletinada);
      const fechaSentinel = "2000-01-01";
      const estado = String(card.estado || "").trim().toLowerCase();
      const esActiva = estado === "activa" || estado === "activo";
      const boletinadaReal = fecha != null && fecha !== fechaSentinel;

      return !esActiva || boletinadaReal;
    },

    aplicarDatosTarjeta(card, user) {
      if (user.documento) {
        this.form.no_documento = String(user.documento);
      }
      if (user.nombre) {
        this.form.nombre = String(user.nombre);
      }
      if (user.email != null && user.email !== "") {
        this.form.email = String(user.email);
      }
      if (user.telefono != null && user.telefono !== "") {
        this.form.telefono = String(user.telefono);
      }
      if (user.direccion != null && user.direccion !== "") {
        this.form.direccion = String(user.direccion);
      }
      if (card.num_externo != null && !this.form.no_tarjeta) {
        this.form.no_tarjeta = String(card.num_externo);
      }
    },

    limpiarFormulario() {
      this.form = {
        no_tarjeta: "",
        no_documento: "",
        nombre: "",
        monto: "",
        referencia: "",
        telefono: "",
        email: "",
        observacion: "",
        departamento: "",
        ciudad: "",
        direccion: "",
        estado: 1,
        tratamiento_datos: false,
        terminos_condiciones: false,
      };
      this.valTarjeta = false;
      this.tarjetaValidada = "";
      this.mensaje = "";
      this.errors = {};
      this.recaptchaToken = null;

      if (this.$v && this.$v.form) {
        this.$v.form.$reset();
      }

      if (this.$refs.wizard) {
        this.$refs.wizard.reset();
      }

      if (this.recaptchaWidgetId !== null && window.grecaptcha) {
        try {
          window.grecaptcha.reset(this.recaptchaWidgetId);
        } catch (e) {
          /* ignore */
        }
      }
    },

    loadRecaptcha() {
      if (window.grecaptcha && window.grecaptcha.render) {
        this.renderRecaptcha();
        return;
      }

      const script = document.createElement("script");
      script.src =
        "https://www.google.com/recaptcha/api.js?onload=vueRecaptchaLoadedEpayco&render=explicit";
      script.async = true;
      script.defer = true;

      window.vueRecaptchaLoadedEpayco = () => {
        this.renderRecaptcha();
      };

      document.head.appendChild(script);
    },

    renderRecaptcha() {
      this.$nextTick(() => {
        const container = document.getElementById("recaptcha-container");
        if (!window.grecaptcha || !container) return;

        // Evitar renderizar dos veces el mismo contenedor
        if (container.innerHTML.trim() !== "" && this.recaptchaWidgetId !== null) {
          return;
        }

        try {
          this.recaptchaWidgetId = window.grecaptcha.render("recaptcha-container", {
            sitekey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
            callback: this.onRecaptchaSuccess,
            "expired-callback": this.onRecaptchaExpired,
            "error-callback": this.onRecaptchaError,
            theme: "light",
            size: "normal",
          });
        } catch (e) {
          // Ya renderizado o contenedor no listo
          console.error("Error al renderizar reCAPTCHA:", e);
        }
      });
    },

    onRecaptchaSuccess(token) {
      this.recaptchaToken = token;
      this.errors.recaptcha = null;
    },

    onRecaptchaExpired() {
      this.recaptchaToken = null;
      this.errors.recaptcha =
        "La verificación reCAPTCHA ha expirado. Por favor, vuelva a verificar.";
      if (this.recaptchaWidgetId !== null && window.grecaptcha) {
        window.grecaptcha.reset(this.recaptchaWidgetId);
      }
    },

    onRecaptchaError() {
      this.recaptchaToken = null;
      this.errors.recaptcha =
        "Error en la verificación reCAPTCHA. Por favor, intente nuevamente.";
    },
  },
};
</script>

<style scoped>
#recaptcha-container {
  margin: 0.5rem 0;
}

.conecta-form-control.is-invalid {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.15);
}

.conecta-form-control.is-valid {
  border-color: #05a85a;
  box-shadow: 0 0 0 0.2rem rgba(5, 168, 90, 0.15);
}

.form-check-input.is-invalid {
  border-color: #dc3545;
}

@media (max-width: 576px) {
  #recaptcha-container {
    transform: scale(0.85);
    transform-origin: center;
  }
}
</style>
